var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1018 8.8435L10.7582 6.49986C10.6459 6.38748 10.4929 6.32812 10.3438 6.32812C10.1934 6.32812 10.0402 6.38889 9.92932 6.49989L7.58569 8.84353C7.35685 9.07236 7.35685 9.44335 7.58569 9.67216C7.81453 9.90097 8.18552 9.901 8.41432 9.67216L9.75782 8.32863V14.4141C9.75782 14.7377 10.0201 15 10.3438 15C10.6674 15 10.9297 14.7377 10.9297 14.4141V8.32863L12.2732 9.67213C12.502 9.90094 12.873 9.90097 13.1018 9.67213C13.3307 9.44332 13.3307 9.0723 13.1018 8.8435Z",
    fill: "#969696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07059 8.50022L8.41431 6.1565C8.64315 5.92767 8.64315 5.55668 8.41431 5.32787C8.18548 5.09906 7.81449 5.09903 7.58568 5.32787L6.24218 6.67137V0.585938C6.24218 0.262324 5.97986 0 5.65625 0C5.33263 0 5.07031 0.262324 5.07031 0.585938V6.67137L3.72681 5.32787C3.49797 5.09903 3.12699 5.09903 2.89818 5.32787C2.66937 5.55671 2.66934 5.9277 2.89818 6.1565L5.2419 8.50022C5.34702 8.60537 5.49725 8.67188 5.65625 8.67188C5.81202 8.67188 5.96366 8.60722 6.07059 8.50022Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/Arrows.8d58b55980d5e349930415bece4decac.svg";
export { ForwardRef as ReactComponent };